import { Directive, ElementRef, inject, output } from '@angular/core';

@Directive({
  selector: '[appViewportEnterDirective]',
  standalone: true
})
export class ViewportEnterDirective {
  private readonly elementRef = inject(ElementRef);
  readonly viewPortEntered = output<void>();
  private observer?: IntersectionObserver;
 ngOnInit(): void {
    this.observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            this.viewPortEntered.emit();
          }
        });
      },
      {
        threshold: 0.1,
        rootMargin: '50px',
      },
    );

    this.observer.observe(this.elementRef.nativeElement);
  }

  ngOnDestroy(): void {
    this.observer?.disconnect();
  }
}
